module.exports = __webpack_public_path__ + "media/assets/events/bg_upper-feb75e0d52f78f408b62733b460ae053.png";